<template>
    <div class="import-form">
        <a-steps v-model="current" type="navigation" size="small" :style="stepStyle">
            <a-step :title="$t('wp.selectContactFile')" :description="$t('wp.selectContactCsvOrExcel')"
                :status="current === 0 ? 'process' : 'wait'" />
            <a-step :title="$t('wp.importConfiguration')" :description="$t('wp.customizeFile')"
                :status="current === 1 ? 'process' : 'wait'" />
        </a-steps>
        <div v-if="current === 0" class="fileSelection">
            <div class="file-box" @click="openSelectFile">
                <div class="">
                    <a-icon type="file-excel" style="font-size: 50px; color: #08c" />
                </div>
                <div class="file-details">
                    <span v-if="file">{{ file.name }}</span>
                    <span>{{ $t("wp.selectFile") }}</span>
                    <span>{{ $t("wp.csvOrExcelFile") }}</span>
                </div>
            </div>
        </div>
        <div v-if="current === 1" class="configuration">
            <div class="left">
                <section class="general">
                    <div class="field">
                        <label> {{ $t("whatsapp.firstRowContainsHeader") }} </label>
                        <a-switch v-model="firstRowContainsHeader" />
                    </div>

                    <div class="field" v-if="!excelMode">
                        <label> {{ $t("whatsapp.separatorCharacter") }} </label>
                        <a-select v-model="seperator">
                            <a-select-option value=",">{{ $t("whatsapp.comma") }}</a-select-option>
                            <a-select-option value=";">{{ $t("whatsapp.semicolon") }}</a-select-option>
                        </a-select>
                    </div>
                </section>
                <a-divider />

                <section class="fields">
                    <section class="headers">
                        <label>{{ $t("whatsapp.supsisField") }}</label>
                        <label></label>
                        <label>{{ $t("whatsapp.excelCsvColumn") }}</label>
                    </section>
                    <div class="field-wrapper" :key="field" v-for="field of Object.keys(mapping)">
                        <div class="field">
                            <a-select :options="getSelectOptionsForFields()" :value="field" :disabled="true" />
                        </div>
                        <i class="material-icons">arrow_forward</i>
                        <div class="field">
                            <a-select :value="mapping[field]" :options="getSelectOptionsForColumns()"
                                @change="(value) => changeFieldValue(field, value)" />
                        </div>
                    </div>
                </section>
            </div>
            <div class="right">
                <section class="result">
                    <label>{{ $t("whatsapp.exampleResultPreview") }}</label>

                    <ve-table :columns="getTableDataSource().columns" :table-data="getTableDataSource().rows"
                        :row-style-option="rowStyleOption" :border-x="true" :border-y="true" row-key-field-name="phone"
                        id="audit-logs-table" :fixed-header="true" />
                </section>
                <section class="footer">
                    <a-button @click="onCancelled">{{ $t("whatsapp.cancel") }}</a-button>
                    <a-button type="primary" @click="save" :loading="importing">
                        {{ importing ? $t("whatsapp.importing") : $t("whatsapp.importContacts") }}
                    </a-button>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import log2 from "../../../../utils/log2";
import { generateRandomId } from "../../../../utils/session";
import _ from "lodash";
import readXlsxFile, { readSheetNames } from "read-excel-file";
import { mapState } from "vuex";
import StringUtils from "../../../../utils/StringUtils";
import { VeLocale, VePagination } from "vue-easytable";
import enUS from "vue-easytable/libs/locale/lang/en-US.js";

Vue.use(VePagination);
VeLocale.use(enUS);

const log = log2("ImportWhatsappContactsFromFile");
export default {
    name: "ImportWhatsappContactsFromFile",
    props: {
        onCompleted: {
            type: Function,
            required: true,
        },
        onCancelled: {
            type: Function,
            required: true,
        },
    },
    data() {
        return {
            rowStyleOption: {
                stripe: true,
            },
            current: 0,
            stepStyle: {
                marginBottom: "20px",
            },
            file: null,
            headers: [],
            firstRowContainsHeader: true,
            seperator: ",",
            fileText: "",
            excelMode: false,
            importing: false,
            mapping: {
                phone: "",
                name: "",
                email: "",
            },
            StringUtils,
            tableKey: 1,
        };
    },
    computed: {
        ...mapState({
            contactProperties: (state) => state.contactProperty.data,
        }),
    },
    created() {
        this.mapping = this.contactProperties.reduce((acc, x) => {
            acc[x._id] = "";
            return acc;
        }, this.mapping);
    },

    methods: {
        clearPhoneNumber(text) {
            return (text || "").toString().replace(/[^0-9]/g, "");
        },
        isSheetEmpty(rows) {
            // Eğer hiç satır yoksa boş
            if (!rows || rows.length === 0) {
                return true;
            }

            // Tüm satırları kontrol et
            for (let row of rows) {
                if (row && row.length > 0) {
                    for (let cell of row) {
                        // Eğer herhangi bir hücrede anlamlı veri varsa boş değil
                        if (cell !== null && cell !== undefined && cell !== "" && cell.toString().trim() !== "") {
                            return false;
                        }
                    }
                }
            }

            // Tüm hücreler boş veya null ise sheet boş
            return true;
        },
        save() {
            this.importing = true;
            setTimeout(() => {
                const lines = this.firstRowContainsHeader ? this.lines.slice(1) : this.lines;

                const contacts = lines.map((line) => {
                    const values = this.excelMode ? line : line.split(this.seperator);
                    const contact = {
                        phone: this.clearPhoneNumber(
                            values[this.headers.findIndex((x) => x.uniqueId === this.mapping.phone)]
                        ),
                        name: values[this.headers.findIndex((x) => x.uniqueId === this.mapping.name)],
                        email: values[this.headers.findIndex((x) => x.uniqueId === this.mapping.email)],
                        contactProperties: this.contactProperties.reduce((acc, x) => {
                            acc.push({
                                id: x._id,
                                value: values[this.headers.findIndex((y) => y.uniqueId === this.mapping[x._id])],
                            });
                            return acc;
                        }, []),
                    };
                    return contact;
                });
                this.onCompleted(contacts);
            }, 10);
        },
        changeFieldValue(field, value) {
            this.mapping[field] = value;
        },

        getSelectOptionsForColumns() {
            return this.headers.map((header) => {
                return {
                    label: header.name,
                    value: header.uniqueId,
                };
            });
        },
        getSelectOptionsForFields() {
            return [
                {
                    label: "Email",
                    value: "email",
                },
                {
                    label: "Name",
                    value: "name",
                },
                {
                    label: "Phone",
                    value: "phone",
                },
                ...this.contactProperties.map((x) => ({
                    label: x.label,
                    value: x._id,
                })),
            ];
        },
        openSelectFile() {
            let fileEl = document.createElement("input");
            fileEl.setAttribute("type", "file");
            fileEl.setAttribute(
                "accept",
                ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            );
            fileEl.onchange = async () => {
                let file = fileEl.files[0];
                log("selected file", file);
                const isExcel = !file.type.includes("text/csv");
                if (file) {
                    this.file = file;
                    log(file);
                    if (isExcel) {
                        readSheetNames(file).then((sheetNames) => {
                            readXlsxFile(file, { sheet: 1 }).then((firstSheetRows) => {
                                const isFirstSheetEmpty = this.isSheetEmpty(firstSheetRows);

                                if (isFirstSheetEmpty && sheetNames.length > 1) {
                                    readXlsxFile(file, { sheet: 2 }).then((secondSheetRows) => {
                                        this.lines = secondSheetRows;
                                        if (!secondSheetRows || secondSheetRows.length === 0 || !secondSheetRows[0] || secondSheetRows[0].length === 0) {
                                            this.$message.error("Eklediğiniz Excel dosyası veri içermiyor. Lütfen geçerli bir dosya seçin.");
                                            this.current = 0;
                                            return;
                                        }
                                        this.parseExcel(secondSheetRows);
                                        this.excelMode = true;
                                        this.current = 1;
                                    });
                                } else {
                                    if (!firstSheetRows || firstSheetRows.length === 0 || !firstSheetRows[0] || firstSheetRows[0].length === 0) {
                                        this.$message.error("Eklediğiniz Excel dosyası veri içermiyor. Lütfen geçerli bir dosya seçin.");
                                        this.current = 0;
                                        return;
                                    }
                                    this.lines = firstSheetRows;
                                    this.parseExcel(firstSheetRows);
                                    this.excelMode = true;
                                    this.current = 1;
                                }
                            });
                        });
                    } else {
                        const text = await this.file.text();
                        this.fileText = text;
                        this.parseCSVText(text);
                        this.current = 1;
                        this.excelMode = false;
                    }
                } else {
                    this.file = null;
                }
            };
            fileEl.click();
        },
        toVariableName(name) {
            return name
                .toString()
                .trim()
                .toLowerCase()
                .split(" ")
                .map((x) => x.trim().replace(/[^a-z0-9_]/g, ""))
                .filter((x) => x.length > 0)
                .join("-");
        },
        parseCSVText(text) {
            let lines = text.split("\n");

            if (!text || text.trim() === "" || lines.length === 0 || lines.every(line => !line || line.trim() === "")) {
                this.$message.error("Eklediğiniz CSV dosyası veri içermiyor. Lütfen geçerli bir dosya seçin.");
                this.current = 0;
                return;
            }

            let result = [];
            this.headers = [];
            this.headers = lines[0].split(this.seperator).map((name, index) => {
                const _name = this.firstRowContainsHeader ? name : `Column ${index + 1}`;
                const id = this.toVariableName(_name);
                const uniqueId = generateRandomId(4);
                if (index === 0) {
                    this.mapping.phone = uniqueId;
                } else if (index === 1) {
                    this.mapping.name = uniqueId;
                } else if (index === 2) {
                    this.mapping.email = uniqueId;
                }
                return {
                    name: _name,
                    index,
                    id,
                    uniqueId,
                };
            });
            this.lines = lines;
            this.mapping = _.cloneDeep(this.mapping);
            this.tableKey = StringUtils.hashCodeObj(this.mapping);
        },
        parseExcel(lines) {
            this.headers = [];
            this.headers = lines[0].map((name, index) => {
                const _name = this.firstRowContainsHeader ? name : `Col-${index + 1}`;
                const id = this.toVariableName(_name);
                const uniqueId = generateRandomId(4);
                if (index === 0) {
                    this.mapping.phone = uniqueId;
                } else if (index === 1) {
                    this.mapping.name = uniqueId;
                } else if (index === 2) {
                    this.mapping.email = uniqueId;
                }

                return {
                    name: _name,
                    index,
                    id,
                    uniqueId,
                };
            });
            this.lines = lines;
            this.mapping = _.cloneDeep(this.mapping);
            this.tableKey = StringUtils.hashCodeObj(this.mapping);
        },
        getTableDataSource() {
            const lines = this.firstRowContainsHeader ? this.lines.slice(1) : this.lines;

            const colLabels = {
                email: "Email",
                name: "Name",
                phone: "Phone",
                ...this.contactProperties.reduce((acc, x) => {
                    acc[x._id] = x.label;
                    return acc;
                }, {}),
            };
            const columns = _.orderBy(
                Object.keys(this.mapping)
                    .filter((x) => (this.mapping[x] || "").length > 0)
                    .map((field, index) => {
                        return {
                            dataIndex: `${index}-${this.mapping[field]}`,
                            priority: ["email", "name", "phone"].indexOf(field),
                            headerIndex: this.headers.findIndex((x) => x.uniqueId === this.mapping[field]),
                            field: `${index}-${this.mapping[field]}`,
                            dataField: field,
                            key: `${index}-${this.mapping[field]}`,
                            title: colLabels[field],
                            align: "left",
                        };
                    }),

                ["priority"],
                ["desc"]
            );

            const rows = _.take(lines, 5).map((line) => {
                const values = this.excelMode ? line : line.split(this.seperator);
                const row = {};
                columns.forEach((col) => {
                    row[`${col.key}`] = values[col.headerIndex];
                });
                return row;
            });
            return {
                columns,
                rows,
            };
        },
    },
    watch: {
        seperator() {
            if (!this.excelMode) this.parseCSVText(this.fileText);
        },
        firstRowContainsHeader() {
            if (this.excelMode) this.parseExcel(this.lines);
            else this.parseCSVText(this.fileText);
        },
    },
};
</script>

<style lang="scss">
.import-form {
    .navs {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .fileSelection {
        display: flex;
        justify-content: center;
        align-items: center;

        .file-box {
            width: 100%;
            height: 200px;
            border: 1px solid #d9d9d9;
            border-radius: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            width: 300px;
            background: azure;

            .file-details {
                display: flex;
                flex-direction: column;
                gap: 10px;
            }
        }
    }

    .configuration {
        display: flex;
        gap: 10px;

        .left {
            width: 50%;
        }

        .right {
            width: 50%;
            overflow-y: auto;
            border-left: 1px solid #d9d9d9;
            padding-left: 10px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            section.footer {
                display: flex;
                justify-content: flex-end;
                gap: 10px;
            }
        }

        section.general {
            display: flex;
            gap: 20px;

            .field {
                display: flex;
                flex-direction: column;

                label {
                    font-size: 16px;
                    color: #232222;
                    font-weight: 600;
                }

                .ant-switch {
                    width: 10px;
                }
            }
        }

        section.headers {
            display: flex;
            gap: 5px;
            justify-content: space-between;
            width: 100%;

            label {
                width: 100%;
            }
        }

        section.fields {
            display: flex;
            flex-direction: column;
            gap: 10px;
            align-items: center;
            width: 100%;

            .field-wrapper {
                display: flex;
                gap: 5px;
                justify-content: space-between;
                width: 100%;

                .field {
                    display: flex;
                    flex-direction: column;
                    min-width: 200px;
                    width: 40%;

                    label {
                        font-size: 16px;
                        color: #232222;
                        font-weight: 600;
                    }

                    .ant-switch {
                        width: 10px;
                    }
                }
            }

            label {
                font-size: 16px;
                color: #232222;
                font-weight: 600;
            }
        }

        section.result {
            display: flex;
            flex-direction: column;
            gap: 20px;

            label {
                font-size: 16px;
                color: #232222;
                font-weight: 600;
            }
        }
    }
}
</style>
